export default __webpack_public_path__ + "static/media/49_1_0.53a67552.png";